import React, { useState } from 'react';
import { styled } from '@mui/material';
import { Palette } from '@mui/icons-material';
import { Colors } from 'library';
import { RColorPickerModal } from './RColorPickerModal';
import { RRow } from './RRow';

interface RColorPickerProps {
    value: string;
    onChange: (color: string) => void;
    presets: string[];
    swatchSize?: number;
}

export function RColorPicker({ value, onChange, presets, swatchSize = 32 }: RColorPickerProps) {
    const [showModal, setShowModal] = useState(false);
    const isCustom = !presets.includes(value);

    return (
        <>
            <RRow gap="sm" align="center">
                {presets.map((color) => (
                    <Swatch
                        key={color}
                        color={color}
                        selected={value === color}
                        size={swatchSize}
                        onClick={() => onChange(color)}
                    />
                ))}
                <CustomButton selected={showModal || isCustom} size={swatchSize} onClick={() => setShowModal(true)}>
                    {isCustom ? (
                        <ColorDot color={value} size={swatchSize - 12} />
                    ) : (
                        <Palette sx={{ fontSize: swatchSize * 0.5, color: Colors.mediumGrey }} />
                    )}
                </CustomButton>
            </RRow>
            {showModal && <RColorPickerModal color={value} onChange={onChange} onClose={() => setShowModal(false)} />}
        </>
    );
}

const Swatch = styled('button')<{ color: string; selected: boolean; size: number }>(({ color, selected, size }) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: color,
    border: selected ? `2px solid ${Colors.darkNavy}` : `2px solid ${Colors.lightGrey}`,
    outline: selected ? `2px solid ${Colors.white}` : 'none',
    cursor: 'pointer',
    padding: 0,
    '&:hover': {
        border: `2px solid ${Colors.darkNavy}`,
    },
}));

const CustomButton = styled('button')<{ selected: boolean; size: number }>(({ selected, size }) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: Colors.faintGrey,
    border: selected ? `2px solid ${Colors.darkNavy}` : `1.5px dashed ${Colors.lightGrey}`,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
}));

const ColorDot = styled('div')<{ color: string; size: number }>(({ color, size }) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: color,
}));
